// extracted by mini-css-extract-plugin
module.exports = {"root":"CircleArrowLink_root__i6hpj","white":"CircleArrowLink_white__m_syN","black":"CircleArrowLink_black__ele33"};